import { cn } from "@/lib/utils";

interface LotteryFilledIconProps extends React.SVGProps<SVGSVGElement> {
  fill?: string;
  className?: string;
}

export const LotteryFilledIcon = ({ fill = "#5EA6FF", className, ...props }: LotteryFilledIconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cn("h-5 w-5", className)}
    aria-label="Lottery"
    role="img"
    {...props}
  >
    <path
      d="M3 4.5C3 3.67157 3.67157 3 4.5 3H15.5C16.3284 3 17 3.67157 17 4.5V15.5C17 16.3284 16.3284 17 15.5 17H4.5C3.67157 17 3 16.3284 3 15.5V4.5Z"
      fill={fill}
      fillOpacity="0.2"
    />
    <path
      d="M4.5 3C3.67157 3 3 3.67157 3 4.5V15.5C3 16.3284 3.67157 17 4.5 17H15.5C16.3284 17 17 16.3284 17 15.5V4.5C17 3.67157 16.3284 3 15.5 3H4.5ZM4.5 4H15.5C15.7761 4 16 4.22386 16 4.5V15.5C16 15.7761 15.7761 16 15.5 16H4.5C4.22386 16 4 15.7761 4 15.5V4.5C4 4.22386 4.22386 4 4.5 4Z"
      fill={fill}
    />
    <circle cx="6" cy="6" r="0.5" fill={fill} />
    <circle cx="6" cy="8.5" r="0.5" fill={fill} />
    <circle cx="6" cy="11" r="0.5" fill={fill} />
    <circle cx="6" cy="13.5" r="0.5" fill={fill} />
    <circle cx="14" cy="6" r="0.5" fill={fill} />
    <circle cx="14" cy="8.5" r="0.5" fill={fill} />
    <circle cx="14" cy="11" r="0.5" fill={fill} />
    <circle cx="14" cy="13.5" r="0.5" fill={fill} />
    <path d="M10 7.5L10.5 9H12L10.75 9.875L11.25 11.375L10 10.5L8.75 11.375L9.25 9.875L8 9H9.5L10 7.5Z" fill={fill} />
  </svg>
);
